import { FEEDBACK_WITH_JSON } from '../../../state/mutations/User';
import { useCameraPermissions, useMicrophonePermissions } from 'expo-camera';
import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { useStores } from '../../../hooks/useStores';

export const useSpecificOnNextLogic = (questionKey: string | undefined | null) => {
  const sendFeedback = useFeedbackOnNext(questionKey || '');
  const askPermission  = useAskPermission();
  switch(questionKey) {
  case 'videocallLanguageFail':
  case 'phoneLanguageFail':
  case 'videocallRegionFail':
  case 'phoneRegionFail':
    return sendFeedback;
  case 'whyPermission':
    return askPermission;
  default: return () => {};

  }

};

const useFeedbackOnNext = (questionKey: string | undefined) => {

  const [feedbackWithJson] = useMutation(FEEDBACK_WITH_JSON, {fetchPolicy:'no-cache'});
  const { user, treeNav } = useStores();

  const sendFeedback = () => {
    feedbackWithJson({
      variables: {
        feedback: JSON.stringify({
          from: 'Unhappy case in instant help survey' ,
          'Company name': user?.user?.companyName,
          questionKey,
          Comment: treeNav.choices.pending?.freeText || '',
        })
      }
    });
  };
  return sendFeedback;

};

const useAskPermission = () => {
  const {requestPermissions } = useVideoPermissions();


  return requestPermissions;

};

export const useVideoPermissions = () => {
  const [cameraPermissions, requestCameraPermissions] = useCameraPermissions();
  const [microphonePermissions, requestMicrophonePermissions] = useMicrophonePermissions();
  const [asking, setAsking] = useState<boolean>(false);
  const requestPermissions = async() => {
    setAsking(true);
    await requestCameraPermissions();
    await requestMicrophonePermissions();
    setAsking(false);
  };

  return {
    cameraPermissions,
    microphonePermissions,
    requestPermissions,
    canAskAgain: cameraPermissions?.canAskAgain && microphonePermissions?.canAskAgain
    && cameraPermissions?.status !== 'denied' && microphonePermissions?.status !== 'denied', // canAskAgain always true even when asking doesn't produce anything
    granted: cameraPermissions?.granted && microphonePermissions?.granted,
    asking
  };
};